import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, ReplaySubject, tap } from "rxjs";
import { environment } from "@env/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Employee } from "./employee.inteface";

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {

    baseUrl = environment.auth_url + '/admin';
    private _employee: ReplaySubject<Employee> = new ReplaySubject<Employee>(1);
    private _employees: BehaviorSubject<Employee[]> = new BehaviorSubject<Employee[]>([]);
    private _metadata: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    set employee(value: Employee) {
        this._employee.next(value);
    }

    get employee$() {
        return this._employee.asObservable();
    }

    set employees(value: Employee[]) {
        this._employees.next(value);
    }

    get employees$() {
        return this._employees.asObservable();
    }

    get metadata$(): Observable<any> {
        return this._metadata.asObservable();
    }

    constructor(
        private _httpClient: HttpClient
    ) { }

    getEmployees(filters?: { page?: number; size?: number; name?: string; email?: string; entityAccessLevel?: string }): Observable<any> {
        let params = new HttpParams();
        if (filters) {
            if (filters.page !== undefined) params = params.set('page', filters.page.toString());
            if (filters.size !== undefined) params = params.set('size', filters.size.toString());
            if (filters.name) params = params.set('name', filters.name);
            if (filters.email) params = params.set('email', filters.email);
            if (filters.entityAccessLevel) params = params.set('entityAccessLevel', filters.entityAccessLevel);
        }
        return this._httpClient.get<any>(`${this.baseUrl}/employees`, { params })
        .pipe(
            tap((response: any) => {
                this._employees.next(response?.content || []);
                this._metadata.next(response);
            }),
            catchError(() => of({ content: [] }))
        );
    }

    getEmployee(id: string): Observable<Employee> {
        return this._httpClient.get<Employee>(`${this.baseUrl}/employees/${id}`)
        .pipe(
            tap((employee) => {
                this.employee = employee;
                return (employee);
            }),
            catchError(() => of({} as Employee))
        );
    }

    updateProfiles(uuid: string, profileIds: string[]): Observable<Employee> {
        return this._httpClient.put<Employee>(`${this.baseUrl}/employees/${uuid}/profiles`, { profileIds })
        .pipe(
            tap((employee) => {
                this.employee = employee;
                return (employee);
            }),
            catchError(() => of({} as Employee))
        );
    }

    activate(uuid: string): Observable<Employee> {
        return this._httpClient.put<Employee>(`${this.baseUrl}/employees/${uuid}/activate`, {})
        .pipe(
            tap((employee) => {
                this.employee = employee;
                return (employee);
            }),
            catchError(() => of({} as Employee))
        );
    }

    deactivate(uuid: string): Observable<Employee> {
        return this._httpClient.put<Employee>(`${this.baseUrl}/employees/${uuid}/deactivate`, {})
        .pipe(
            tap((employee) => {
                this.employee = employee;
                return (employee);
            }),
            catchError(() => of({} as Employee))
        );
    }
}
